var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHikeLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22680_71354",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9856 29.992H6.9059C6.65072 29.992 6.44338 29.7847 6.44338 29.5295V24.0112C6.44338 23.756 6.23605 23.5486 5.98086 23.5486H0.462515C0.207332 23.5486 0 23.3413 0 23.0861V18.118C0 17.8628 0.207332 17.6555 0.462515 17.6555H10.7815C11.6986 17.6555 12.4402 18.3971 12.4402 19.3142V29.5295C12.4482 29.7927 12.2408 29.992 11.9856 29.992ZM0.0079701 2.87081C0.0079701 1.28389 1.29187 0 2.87879 0H15C23.2456 0 30 6.75438 30 15C30 23.2456 23.2456 30 15 30H14.9761L18.0223 26.9537C18.5726 26.4035 18.8836 25.6539 18.8836 24.8644V13.7799C18.8836 12.3684 17.7432 11.2281 16.3317 11.2281H5.24721C4.46571 11.2281 3.71611 11.5391 3.15789 12.0893L0 15.2472V2.87081H0.0079701Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22680_71354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 0H0.0078125V30H29.9998V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHikeLogoSmall);
export default __webpack_public_path__ + "static/media/hike_logo_small.bac1238087e229cfef49194b26848778.svg";
export { ForwardRef as ReactComponent };